// src/icons.js
import { library } from '@fortawesome/fontawesome-svg-core';

// استيراد مجموعات أيقونات
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

// إضافة كل الأيقونات لمكتبة FontAwesome
library.add(fas, far, fab);
